import PieChartIcon from '@mui/icons-material/PieChart'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import type { IconOwnProps } from '@mui/material/Icon'
import React from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'

import Navigator, { TNavigatorItem } from '@/app/component/atom/navigator'
import SidebarLayout from '@/app/component/layout/sidebar-layout'

import Quotas from './components/quotas'
import WATemplates from './components/wa-templates'

export enum ContentTab {
  Quotas = 'quotas',
  WaTemplates = 'wa-templates',
}

type Props = {
  contentType?: ContentTab
}

const navigatorItems: TNavigatorItem<ContentTab>[] = [
  {
    icon: (color: IconOwnProps['color']) => <WhatsAppIcon color={color} />,
    label: 'WhatsApp Templates',
    path: ContentTab.WaTemplates,
  },
  {
    icon: (color: IconOwnProps['color']) => <PieChartIcon color={color} />,
    label: 'Quotas',
    path: ContentTab.Quotas,
  },
]

export default function Content(props: Props) {
  const navigate = useNavigate()

  const { contentType = ContentTab.WaTemplates } = props

  const handleItemClick = React.useCallback(
    (selectedTab: string) => {
      navigate(`/content/${selectedTab}`)
    },
    [navigate],
  )

  const sidebar = (
    <div>
      <Navigator
        activePath={contentType}
        id="content"
        items={navigatorItems}
        title="Content"
        onItemClick={handleItemClick}
      />
    </div>
  )

  const content = (
    <>
      {contentType === ContentTab.WaTemplates && <WATemplates />}
      {contentType === ContentTab.Quotas && <Quotas />}
    </>
  )

  return <SidebarLayout sidebar={sidebar} content={content} />
}
